module.exports = __webpack_public_path__ + "static/media/metasection.0e57fdcf.png";